import { useEffect, useState, useCallback } from 'react';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import Button from '@/components/atoms/button/button';
import { IModalRequestShiftProps } from '@/interfaces/qanty';
import { convertTimeSeconds } from '@/utils/convertTimeSeconds';

import CloseBtn from '../../../assets/images/icons/close_black_24dp.svg';
import './modalRequestShift.scss';
import { getAssetUrl } from '@/utils/contentFullAsset';

const ModalRequestShift = ({
  onClose,
  modalContent,
  onCancel,
  onAccept,
  onAcceptCancel,
  isAccept,
  loader,
  listInfo,
}: IModalRequestShiftProps) => {
  const modalContentToggle = isAccept ? modalContent[1] : modalContent[0];
  const [finishTimer, setFinishTimer] = useState(false);
  const [timer, setTimer] = useState(
    listInfo.info?.wait_metrics?.waiting_time || listInfo.info?.wait_metrics?.wait_estimate || 0,
  );
  useEffect(() => {
    setTimeout(() => {
      onClose();
    }, 10000);
  }, []);

  const convertTimeInterval = useCallback(() => {
    return setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
        return;
      }
      setFinishTimer(true);
    }, 1000);
  }, [timer]);

  useEffect(() => {
    const interval = convertTimeInterval();

    if (timer === 0) {
      setFinishTimer(true);
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [finishTimer, timer]);

  return (
    <div className="m-modal-request-shift">
      <figure className="m-modal-request-shift__closeBtn" onClick={onClose}>
        <img src={CloseBtn} alt="closeButton" />
      </figure>

      <article className="m-modal-request-shift__content">
        <figure className="m-modal-request-shift__content__img">
          <img
            src={getAssetUrl(modalContentToggle.imagen[0])}
            alt={modalContentToggle.imagen[0].file.title}
          />
        </figure>
        <aside className="m-modal-request-shift__content__title">
          <h2>
            {modalContentToggle.titulo} {isAccept && listInfo.info?.name}
          </h2>
        </aside>
        <aside className="m-modal-request-shift__content__subtitle">
          <h2>{modalContentToggle.subtitulo}</h2>
        </aside>
        {isAccept && (
          <aside className="m-modal-request-shift__content__wait">
            <p>
              {timer > 300 ? modalContentToggle.nombre : ' '}{' '}
              {timer > 300
                ? convertTimeSeconds(timer)
                : 'Tu turno esta proximo a ser llamado, acercate a la sede lo mas pronto posible'}
            </p>
          </aside>
        )}
        {isAccept ? (
          <aside className="m-modal-request-shift__content__address">
            <div className="branch">
              <h2>{modalContentToggle.lista[0]}</h2>
              <div>
                <p className="branch__name">{listInfo.info?.branch?.name}</p>
                <p className="branch__address">{listInfo.info?.branch?.address}</p>
              </div>
            </div>
            <div className="service">
              <h2 className="service__title">{modalContentToggle.lista[1]}</h2>
              <p>{listInfo.info?.current_line?.name}</p>
            </div>
          </aside>
        ) : (
          <aside className="m-modal-request-shift__content__description">
            <h2> {documentToReactComponents(JSON.parse(modalContentToggle.descripcion.raw))}</h2>
          </aside>
        )}
        <aside className="m-modal-request-shift__content__buttons">
          {!isAccept && (
            <>
              <Button
                type="button"
                classname="secondary accept"
                text={modalContentToggle.boton[1].copy}
                onClickAction={isAccept ? onAccept : onAcceptCancel}
                isDisabled={false}
                loader={loader}
              />
              <Button
                type="button"
                classname="primary cancel"
                text={modalContentToggle.boton[0].copy}
                onClickAction={onCancel}
                isDisabled={false}
              />
            </>
          )}
        </aside>
      </article>
    </div>
  );
};

export default ModalRequestShift;
